export enum StatusSeverities {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export enum StatusColors {
  Error = 'red-500',
  Warning = 'orange-500',
  Info = 'blue-500',
  Success = 'green-500',
}

export enum StatusIcons {
  Error = 'hazard',
  Warning = 'circle-warning',
  Info = 'circle-info',
  Success = 'circle-check',
}

export type StatusSeverity = `${StatusSeverities}`;
export type StatusColor = `${StatusColors}`;
export type StatusIcon = `${StatusIcons}`;
